module.exports = __webpack_public_path__ + "img/ly.702af684.jpg";